export const teamTypes = {
  EMPLOYEES_CLOCKED_IN: "employeesClockedIn"
};

export const teamLabels = {
  "Employees Clocked In": teamTypes.EMPLOYEES_CLOCKED_IN
};
